import { useTimeout } from "@mantine/hooks";
export default useTimeout;
